import ES from "./es.json";

const KEY = "app_lang";
const params = new URLSearchParams(window.location.search);
const fromUrl = params.get("lang");
if (fromUrl === "es" || fromUrl === "en") localStorage.setItem(KEY, fromUrl);
else if (!localStorage.getItem(KEY) && localStorage.getItem("learn_lang")) localStorage.setItem(KEY, localStorage.getItem("learn_lang"));

// Language is fixed for the page lifetime; switching reloads so module-level text re-evaluates.
export const LANG = localStorage.getItem(KEY) === "es" ? "es" : "en";
document.documentElement.lang = LANG;

export const t = (s) => (LANG === "es" && typeof s === "string" ? ES[s] ?? s : s);

export const switchLang = (lang) => {
  localStorage.setItem(KEY, lang);
  const url = new URL(window.location.href);
  url.searchParams.delete("lang");
  window.location.replace(url.toString());
};

// Adopt the language saved on the account (without a reload loop if it already matches).
export const URL_LANG = fromUrl === "es" || fromUrl === "en" ? fromUrl : null;

// Adopt the language saved on the account; optionally land on `target` after the reload.
export const adoptAccountLang = (lang, target) => {
  if ((lang !== "es" && lang !== "en") || lang === LANG) return false;
  localStorage.setItem(KEY, lang);
  if (target) window.location.assign(target);
  else switchLang(lang);
  return true;
};

export const withLang = (url) => {
  if (LANG !== "es") return url;
  const u = new URL(url, window.location.origin);
  u.searchParams.set("lang", "es");
  return u.toString();
};
